<template>
<div class="main">
  <app-header :cikis="cikis" :fad="fad"></app-header>
    <div class="d-flex align-items-stretch">
      <!-- Sidebar Navigation-->
      <nav id="sidebar">
        <!-- Sidebar Header-->
        <div class="sidebar-header d-flex align-items-center">
          <div class="avatar dashtext-3">
           <!-- <img src="/set/img/avatar-6.jpg" alt="..." class="img-fluid rounded-circle">-->
          </div>
          <div class="title">
            <h1 class="h5">{{isim}}</h1>
            <p>{{tip}}</p>
          </div>
        </div>
        <!-- Sidebar Navidation Menus--><span class="heading">Servis İşlem</span>

        <ul class="list-unstyled"> 
          <li class="active" v-if="$helper.sayfayetki(610696)">
            <router-link to="/create/servis"> <i class="fa fa-plus"></i>Yeni Servis </router-link>
          </li>
          <li><router-link to="/liste/servis/bekleyen"><i class="icon-grid"></i>Bekleyen </router-link></li>
          <li><router-link to="/liste/servis/yonlendirilen"> <i class="fa fa-bar-chart"></i>Yönlendirilen </router-link></li>
          <li><router-link to="/liste/servis/devameden"> <i class="icon-logout"></i>Devameden </router-link> </li>
          <li><router-link to="/liste/servis/tamamlanan"> <i class="icon-padnote"></i>Tamamlanan </router-link></li>
<!--<span style="color:#fff" class="badge dashbg-3">0</span>-->
          <!-- Sidebar Navidation Menus--><span class="heading">Listeleme - Rapor</span>
        
          <li v-if="$helper.sayfayetki(691274)">
            <router-link to="/rapor/servis"><i class="fa fa-bar-chart"></i>Servis</router-link>
          </li>

          <li v-if="$helper.sayfayetki(771713)"> 
            <router-link to="/liste/cihaz"><i class="icon-settings"></i>Cihaz</router-link>
          </li>

          <li v-if="$helper.sayfayetki(982595)"> 
            <router-link to="/liste/cari"><i class="fa fa-address-card"></i>Cari</router-link>
          </li>

          <li v-if="$helper.sayfayetki(845326)">
            <router-link to="/liste/kullanici"><i class="fa fa-user"></i>Kullanıcı</router-link>
          </li>

          <li v-if="$helper.sayfayetki(319839)">
            <a href="#define" aria-expanded="false" data-toggle="collapse"> <i class="icon-windows"></i>Tanımlama </a>
            <ul id="define" class="collapse list-unstyled ">
          <li> <router-link to="/defines/sa"><i class="icon-settings"></i>Sağlayıcı</router-link></li>              
          <!--<li> <router-link to="/defines/sd"><i class="icon-settings"></i>Servis Durumu</router-link></li>-->
          <li> <router-link to="/gruplama/sn"><i class="icon-settings"></i>Servis Nedeni</router-link></li>
          <li> <router-link to="/defines/so"><i class="icon-settings"></i>Servis Sırası</router-link></li>
          <!--<li> <router-link to="/defines/st"><i class="icon-settings"></i>Servis Tipi</router-link></li>-->
          <li> <router-link to="/defines/cd"><i class="icon-settings"></i>Cihaz Durumu</router-link></li>
          <li> <router-link to="/gruplama/ariza"><i class="icon-settings"></i>Arıza Kodu</router-link></li>
          <li> <router-link to="/defines/bolge"><i class="icon-settings"></i>Bölge</router-link></li>
          <li> <router-link to="/create/ekip"><i class="icon-settings"></i>Ekip</router-link></li>
         <!-- <li> <router-link to="/defines/ktip"><i class="icon-settings"></i>Kullanıcı Tip</router-link></li>
          <li>
            <router-link to="/create/kullanici"><i class="icon-settings"></i>Kullanıcı</router-link>
          </li>-->
          <!--<li>
            <router-link to="/defines/cihazgrup"><i class="icon-settings"></i>Cihaz Grup
            </router-link>
          </li>-->
            </ul>
          </li>
        </ul>  
      </nav>
      <div class="page-content"><router-view></router-view></div>
      
      </div>
      
</div>
</template>

<script>
import { decode } from 'js-base64';
import appHeader from './header'

export default {
  name: 'app',
    components: {
      appHeader
    },
       data() {
        return {
            fad:decode(this.$request.ayar().genel.f),
            isim:decode(this.$request.ayar().genel.k),
            tip:decode(this.$request.ayar().genel.t),
        }
  },
    methods: {
      cikis(){
          this.$helper.logout();
      },
        onBack() {
        window.history.back();
        //this.$route.go("/hesap")
        },
    }  
 
}
</script>



// WEBPACK FOOTER //
// src/component/content.vue